/**
 * O tracinho que liga o andar aos seus BOX.
 *
 * Um andar de coluna dupla tem duas profundidades (601 e 602). Desenhar a
 * forquilha deixa claro que são o MESMO andar, e não dois:
 *
 *         ┌ 601
 * Andar 6 ┤
 *         └ 602
 *
 * Rua de coluna simples não desenha forquilha nenhuma — quem chama decide,
 * olhando quantas profundidades a rua tem.
 *
 * Vive aqui, e não dentro de uma tela, porque as duas elevações do sistema
 * (a do Estoque e a das Transferências) desenham o mesmo rack: duplicar o
 * traço é como uma ganha o ajuste e a outra não.
 */
export function Ramo({ primeiro, ultimo }: { primeiro: boolean; ultimo: boolean }): JSX.Element {
  return (
    <span aria-hidden className="relative mr-1 h-full w-2.5 shrink-0">
      {/* tronco: desce do andar de cima e segue para o de baixo */}
      {!primeiro ? <span className="absolute left-0 top-0 h-1/2 w-px bg-bordaForte" /> : null}
      {!ultimo ? <span className="absolute bottom-0 left-0 h-1/2 w-px bg-bordaForte" /> : null}
      {/* galho: sai do tronco na altura desta linha */}
      <span className="absolute left-0 top-1/2 h-px w-full bg-bordaForte" />
    </span>
  );
}
